<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">    
  	  <div class="backborder3" style="padding:1% 1% 1% 1%">
          <div class="statout" style="background:#F56C6C;" v-if="query.type==1">
          	  <img src="../../static/images/getmoney.png"/>
          	  <span class="number">{{paycustomernumber}}</span>
          	  <span class="desc">总欠款客户（家）</span>
          </div>
          <div class="statout" style="background:#F56C6C;" v-if="query.type==2">
          	  <img src="../../static/images/getmoney.png"/>
          	  <span class="number">{{paycustomernumber}}</span>
          	  <span class="desc">待收款销售员（人）</span>
          </div>
          <div class="statout" style="background:#E6A23C;" v-if="query.type==1">
          	  <img src="../../static/images/getallmoney.png"/>
          	  <span class="number">{{paymoney.money}}</span>
          	  <span class="desc">欠款合计（{{paymoney.unit}}）</span>
          </div>
          <div class="statout" style="background:#E6A23C;" v-if="query.type==2">
          	  <img src="../../static/images/getallmoney.png"/>
          	  <span class="number">{{paymoney.money}}</span>
          	  <span class="desc">待收款合计（{{paymoney.unit}}）</span>
          </div>
          <div class="statout" style="background:#67C23A;">
          	  <img src="../../static/images/customers.png"/>
          	  <span class="number"><a href="javascript:;" @click="getAllcustomers">{{allcustomernumber}}</a></span>
          	  <span class="desc">总客户（家）</span>
          </div>	
      </div>
    
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder3 demo-form-inline" size="small" style="margin-top:10px;padding-bottom:0">
      	  <el-form-item style="width:10%">
      	  	  <el-select v-model="query.type" filterable  @change="orderisselect=true" style="width:100%">
		          <el-option v-for="(item,index) in typelists" :key="index" :label="item.name" :value="item.id"></el-option>
		      </el-select> 
      	  </el-form-item>
      	  <el-form-item v-if="query.type==1">
    		  <el-select v-model="query.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="orderisselect=true" style="width:100%">
		          <el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
		      </el-select> 
    	  </el-form-item>
    	  <el-form-item style="width:12%" v-if="query.type==2">
    		  <el-select v-model="query.seller" clearable filterable placeholder="请选销售员" @change="orderisselect=true" style="width:100%">
				  <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
			  </el-select>
    	  </el-form-item>
    	  <el-form-item style="width:21%">
			  <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="orderisselect=true" style="width:100%"></el-date-picker>	
		  </el-form-item> 
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
      </el-form>
      <!------------------------search end---------------------->
      
      <div class="backborder3" style="margin:10px 0 2% 0">
	      <el-table :data="lists" v-loading="listLoading">
	      	  <el-table-column prop="name" label="名称"></el-table-column>
	          <el-table-column prop="total" label="应收款合计" width="180" align="center"></el-table-column>
	          <el-table-column label="操作" width="120" align="center">
		          <template slot-scope="scope">
		              <!--<el-button type="primary" size="mini" icon="el-icon-zoom-in" @click="showOrder(scope.row)">详细</el-button>-->
		              <el-button type="primary" size="small" icon="el-icon-document" @click="showOrder(scope.row)" v-if="actionauth.stat_collection_settle=='true'" circle></el-button>
		          </template>
	          </el-table-column>
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="pageSizeChange"
	              @current-change="pageCurrentChange"
	              :current-page="query.p"
	              :page-sizes="[10, 20, 50 ,1000]"
	              :page-size="query.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
      </div>

      <!-------------------------------------详情列表---------------------------------->
      <el-dialog title="待结算订单" :visible.sync="orderDialog" width="87%" top="5vh">
          <el-table ref="multipleTable" :data="orderlists" style="width: 100%" v-loading="orderListLoading" @selection-change="handleSelectionChange" @row-click="selectorder">
          	  <el-table-column type="selection" width="35" align="center"></el-table-column>
          	  <el-table-column type="expand">
	              <template slot-scope="props">
	                  <el-table :data="props.row.goods" border>
		                <el-table-column prop="name" label="商品名称"></el-table-column>
		                <el-table-column prop="spec" label="规格" width="80" align="center"></el-table-column>
		                <el-table-column prop="num" label="数量" width="80" align="center"></el-table-column>
		                <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
		                <el-table-column prop="sell" label="单价" width="100" align="center"></el-table-column>
		                <el-table-column prop="discount" label="折扣（%）" width="100" align="center"></el-table-column>
		                <el-table-column prop="dis_sell" label="折后单价" width="100" align="center"></el-table-column>
		                <el-table-column prop="total" label="小计" width="100" align="center"></el-table-column>
		                <el-table-column prop="type" label="类型" width="80" align="center"></el-table-column>
	                  </el-table>
	              </template>
              </el-table-column>
          
              <el-table-column prop="documents" label="订单编号"></el-table-column>
              <el-table-column prop="customername" label="客户名称" v-if="query.type==2" align="center" width="120"></el-table-column>
              <el-table-column prop="clerkname" label="销售员" v-if="query.type==1" align="center" width="120"></el-table-column>
              <el-table-column prop="inputtime" label="下单时间" align="center" width="120"></el-table-column>
              <el-table-column prop="total" label="订单总价" align="center" width="110"></el-table-column>
              <el-table-column prop="derate" label="优惠金额" align="center" width="110"></el-table-column>
              <el-table-column prop="real" label="应付金额" align="center" width="110"></el-table-column>
              <el-table-column prop="express" label="快递费" align="center" width="110"></el-table-column>
              <el-table-column prop="amount" label="已付金额" align="center" width="110"></el-table-column>
              <el-table-column label="待付款金额" align="center" width="110">
              	  <template slot-scope="scope">
	              	  <span style="color:#F56C6C">{{scope.row.payamount}}</span>
	          	  </template>
              </el-table-column>
          </el-table>
          <div class="block">
              <!--分页begin-->
              <el-pagination
                  @size-change="orderPageSizeChange"
                  @current-change="orderPageCurrentChange"
                  :current-page="orderquery.p"
                  :page-sizes="[10, 20, 50]"
                  :page-size="orderquery.rollpage"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total_order_rows">
              </el-pagination>
              <!--分页end-->
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="orderDialog = false">取 消</el-button>
              <el-button size="medium" type="danger" icon="el-icon-edit-outline" :loading="settlemoreLoading" @click="settlemoreSave">结算</el-button>
          </div>
      </el-dialog>
      <!--------------------------------end--------------------------->

      <!------------------------结算---------------------->
      <el-dialog title="结算" :visible.sync="settleDialog" width="30%">
          <el-form ref="settle" :model="settle" label-width="100px" size="small">
              <el-col :span="22">
	              <el-form-item label="名称" prop="name">
	                  <el-input v-model="settle.name" readonly></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="22">
	              <el-form-item label="结算金额" prop="total">
	                  <el-input v-model="settle.total" readonly><template slot="append">元</template></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="22">
	              <el-form-item label="付款方式">
	                  <el-select v-model="settle.account">
	                  	  <el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id"></el-option>
	                  </el-select>
	              </el-form-item>
              </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="settleDialog = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="settleLoading" @click="settleSave">确 认</el-button>
          </div>
      </el-dialog>
        
      <!------------------------结算订单信息类表 ---------------------->
      <el-dialog :title="showname" :visible.sync="jsDialog" width="85%" top="5vh">
          <el-table :data="orderlists" style="width: 100%" v-loading="orderListLoading">
              <el-table-column prop="documents" label="订单编号"></el-table-column>
              <el-table-column prop="total" label="订单总价" align="center"></el-table-column>
              <el-table-column prop="real" label="实付金额" align="center"></el-table-column>
              <el-table-column prop="amount" label="已结算金额" align="center"></el-table-column>
              <el-table-column prop="refund" label="退货金额" align="center"></el-table-column>
              <el-table-column label="待支付金额" align="center">
              	  <template slot-scope="scope">
	              	  <span style="color:#F56C6C">{{scope.row.pay}}</span>
	          	  </template>
              </el-table-column>
              <el-table-column prop="inputtime" label="订单时间" align="center"></el-table-column>
          </el-table>
          <div class="block">
          	  <!--分页begin-->
              <el-pagination
                  @size-change="orderPageSizeChange"
                  @current-change="orderPageCurrentChange"
                  :current-page="orderquery.p"
                  :page-size="orderquery.rollpage"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total_order_rows">
              </el-pagination>
          	  <!--分页end-->
          </div>
          <div slot="footer" class="dialog-footer">
	          <el-button size="small" @click="jsDialog = false">取 消</el-button>
	          <el-button size="small" type="primary" :loading="addProductLoading" @click="savepay">确认添加</el-button>
      	  </div>
      </el-dialog>
      
      <!-----------------------------  支付总价信息 --------------------------------->
      <el-dialog title="结算" :visible.sync="settlemoreDialog" width="25%" top="15vh">
      	  <el-form size="small">
              <el-col :span="22">
	              <el-form-item label="结算总额">
	              	  <el-col :span="18">
	                  	  <el-input v-model="settlemore.payamount" readonly></el-input>
	                  </el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="22">
	              <el-form-item label="优惠金额">
	              	  <el-col :span="18">
	                  	  <el-input v-model="settlemore.derate" @blur="changederate"></el-input>
	                  </el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="22">
	              <el-form-item label="支付方式">
	              	  <el-col :span="18">
		                  <el-select v-model="settlemore.account">
		                  	  <el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id"></el-option>
		                  </el-select>
	                  </el-col>
	              </el-form-item>
              </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
	          <el-button size="small" @click="settlemoreDialog = false">取 消</el-button>
	          <el-button size="small" type="danger" icon="el-icon-edit-outline" :loading="addpayLoading" @click="addpay">结算</el-button>
      	  </div>
      </el-dialog>
      
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Customer/index",
      lists:[],
      listLoading:false,
      query:{
        act:'collection',
        token:this.$cookies.get('token'),
        type:1,
        date:'',
        seller:'',
        customerid:'',
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_rows: 0,
      paycustomernumber:0,
      allcustomernumber:0,
      paymoney: {
      	  unit:'',
      	  money:0.00,
      },
      orderDialog:false,
      orderlists:[],
      orderListLoading:false,
      orderquery:{
        act:'getpayorder',
        token:this.$cookies.get('token'),
        date:'',
        type:'',
        id:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_order_rows: 0,
      settleDialog:false,
      accountLists:[],
      settle:{
        act:'settle',
        token:this.$cookies.get('token'),
        total:'',
        account:'',
        id:''
      },
      settleLoading:false,
      jsDialog:false,
      showname:'',
      addProductLoading:false,
      multipleSelection:[],
      sellids:'',
      totals:'',
      showordertotalDialog:false,
      addpayLoading:false,
      orderisselect:false,
      customerLists:[],
      customerLoading:false,
      sellerLists:[],
      typelists:[
      	  {id:1,name:'按客户'},
      	  {id:2,name:'按销售员'},
      ],
      orderlistsstatus:[],
      orderselectids:[],
      settlemoreLoading:false,
      settlemoreDialog:false,
      settlemore:{
      	  ids:'',
      	  act:'savesettlemore',
      	  token:this.$cookies.get('token'),
      	  derate:0.00,
      	  payamount:0.00,
      	  account:'',
      },
    }
  },
  mounted(){
    this.getList();
    this.getactionauth();
    this.getAccount(); //获取支付账号
    this.getSeller(); //获取销售员列表
  },
  
  methods:{
  
    /** 获取操作权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  
  
    /** 信息列表 **/
    getList(){
        this.listLoading = true;
        var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.listLoading = false;
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.lists = result.lists;
	            this.paycustomernumber=result.number;
	            this.allcustomernumber=result.customernumber;
	            this.paymoney.unit=result.pay.unit;
	            this.paymoney.money=result.pay.money;
	            this.total_rows=parseInt(res.data.count);
	            this.listLoading = false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.listLoading=false;
        });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    
    /** 应付账款详情 **/
    showOrder(item){
        this.orderquery.id=item.id;
        this.orderquery.type=this.query.type;
        this.orderquery.date=this.query.date;
        this.orderquery.p=1;
        this.orderquery.rollpage=10;
        this.orderDialog=true;
        this.getOrderList();
    },
    
    
    /** 未结算的订单列表 **/
    getOrderList(){
        this.orderListLoading = true;
        var resource = this.$resource(this.url);
        resource.query(this.orderquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.orderListLoading = false;
	        }else{
	            this.orderlists = JSON.parse(Base64.decode(res.data.Data));
	            this.total_order_rows=parseInt(res.data.count);
	            this.orderListLoading = false;
	            
	            //清空选中的订单,并往里写入如选中订单状态为未选中
                var _this=this;
                this.orderlistsstatus=[];
                this.orderselectids=[];
                this.orderlists.forEach(function(item,i) {
                	_this.orderlistsstatus.push(0);
                });
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.orderListLoading=false;
        });
    },
    orderPageSizeChange(val) {
        this.orderquery.rollpage = val;
        this.getOrderList();
    },
    orderPageCurrentChange(val) {
        this.orderquery.p = val;
        this.getOrderList();
    },
    
    
    /** 获取银行帐户 **/
    getAccount(){
        var resource = this.$resource(this.GLOBAL.domain+"Account/index");
        resource.query({act:'lists',isdeposit:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.accountLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取客户 **/
    getCustomer(query){
        if (query !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
	            }else{
		            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.customerLoading = false;
	        });
        }
    },
    
    
    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));	                      
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取结算订单列表 **/
    settleCurrent(item){   
    	this.getorderquery.customerid=item.id;
    	this.showname=item.name+'的未结算订单';
      	this.getOrderList();
      	this.jsDialog=true;
    },
    
    settleSave(){
        this.settleLoading=true;
        var resource = this.$resource(this.url);
        resource.save(this.settle).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.settleLoading=false;
            }else{
	            this.$message.success("订单批量结算成功");
	            this.settleDialog=false;
	            this.settleLoading=false;
	            this.orderDialog=false;
	            this.getList();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.settleDialog=false;
            this.settleLoading=false;
        });
    },
    
    //单行点击触发
    selectorder(row) {       	
    	var _this=this;
    	var number=this.orderselectids.indexOf(row.id);
    	number==-1 ? this.orderselectids.push(row.id) : this.orderselectids.splice(number,1);  	
    	
    	this.orderlists.forEach(function(item,i) { //更新商品的状态
    		//勾选/取消勾选订单
    		if(item.id==row.id) _this.$refs.multipleTable.toggleRowSelection(_this.orderlists[i]);
    	
			//查询订单id在选中的数组里是否存在
			if(_this.orderselectids.indexOf(item.id)!=-1) {
				_this.orderlistsstatus[i]=1;
			}else {
				_this.orderlistsstatus[i]=0;
			}
			
		});  	
    },
    
    //订单列表选择有变动时触发
    handleSelectionChange(val) {
    	var _this=this;
    	this.orderselectids=[]; //清空获取的订单id
		val.forEach(function(item,i) {_this.orderselectids.push(item.id);}); //获取已选中的订单id
		this.orderlists.forEach(function(item,i) { //更新商品的状态
			//查询订单id在选中的数组里是否存在
			if(_this.orderselectids.indexOf(item.id)!=-1) {
				_this.orderlistsstatus[i]=1;
			}else {
				_this.orderlistsstatus[i]=0;
			}
			
		});   	
    	
    },
    
    
    /** 保存结算 **/
    savepay() {
    	if(this.multipleSelection.length==0) {this.$message.error("请选择要结算的订单");return false;}
    	this.addProductLoading=true;
    	
    	var resource = this.$resource(this.url);
      	resource.save({act:'getpaymessage',param:this.multipleSelection,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addProductLoading=false;
            }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
	            this.settle.total=result.totals;
	            this.settle.id=result.ids;
	            this.settle.account='';
	            this.addProductLoading=false;
	            this.showordertotalDialog=true;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.addProductLoading=false;
        });
    },
    
    
    /** 结算 **/
    addpay() {
    	if(this.settlemore.account=='') {this.$message.error("请选择支付方式");return false;}
    	this.addpayLoading=true;
    	
    	var resource = this.$resource(this.url);
        resource.save(this.settlemore).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addpayLoading=false;
            }else{
	            this.$message.success("批量结算订单成功");
	            this.addpayLoading=false;
	            this.settlemoreDialog=false;
	            this.orderDialog=false;
	            this.getList();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.addpayLoading=false;
        });
    },
    
    
    //获取订单批量结算信息
    settlemoreSave() { 
    	if(this.orderselectids.length==0) {this.$message.error("请选择要结算的订单");return false;}
    	if(this.orderselectids.length > 10) {this.$message.error("请不要单次结算超过10个订单");return false;}
    
    	this.settlemoreLoading=true;
    	var resource = this.$resource(this.url);
        resource.save({act:'getmoreamount',token:this.$cookies.get('token'),ids:this.orderselectids}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.settlemoreLoading=false;
            }else{
            	var result = JSON.parse(Base64.decode(res.data.Data));
            	this.settlemore.ids=this.orderselectids;
            	this.settlemore.payamount=result;
            	this.settlemore.derate=0.00;
            	this.settlemore.account='';
	            this.settlemoreLoading=false;
	            this.settlemoreDialog=true;    
            }
        }).catch((res) => {
            this.settlemoreLoading=false;
        });
    },
    
    
    //修改结算优惠金额
    changederate() {
    	if(this.settlemore.derate > this.settlemore.payamount) {
    		this.$message.error("优惠金额不能大于结算总额");
    		this.settlemoreSave();
    		//this.settlemore.derate=0.00;
    		return false;
    	}
    	
    	var pay=this.settlemore.payamount;
    	this.settlemore.payamount=(pay-this.settlemore.derate).toFixed(2);
    },
    
    /** 点击客户总数 **/
    getAllcustomers() {
    	this.$emit('listenchild',{name:'客户管理',url:'Customer'});
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 1% 1%;}
.statout {position:relative;width:20%;height:5%;margin-right:2%;float:left;border:1px solid #E4E7ED;border-radius:5px}
.statout img {float:left;width:24%;padding:6% 5%}
.statout .number {float:left;width:61%;padding-left:5%;margin-top:8%;color:#fff;font-weight:bold;font-size:20px;}
.statout .number a {text-decoration:underline;color:#fff}
.statout .desc {float:left;width:61%;padding-left:5%;margin-top:0;color:#fff;font-size:14px;text-align:left;border:none}
</style>


// WEBPACK FOOTER //
// src/components/stat/Collection.vue